module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Chapter One")]), _vm._v(" "), _c('p', {
    staticClass: "subtb"
  }, [_c('em', {
    staticClass: "ITALIC"
  }, [_vm._v("Ten years later")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("‘Y")]), _vm._v("ou should marry me.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘What? Why?’ Beth gripped the couch’s worn velvet arms as though to ground herself in a world gone mad. Or perhaps she had misheard Ren’s stark statement.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘It is the best solution.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘To what exactly? That you’ve been suffering from unrequited love during the ten years of your absence?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Of course not,’ Ren said, with typical bluntness.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beth felt almost reassured. At least he had not entirely taken leave of his senses.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘If it is because of Father’s death, you need not do so. Jamie and I will fare well enough.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Not if you marry the Duke, you won’t,’ Ren said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘You heard?’ Beth felt her energy sap, her spine bending. Her breath was released in a muted exhalation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Bad news travels fast.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I have not... He asked me to marry him, but it would be the very last resort. If I could think of no other option.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘It would be a catastrophe.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Did he think she did not know this? Even now, her stomach was a tight, hard knot of dread and too often she lay awake at night, clammy with sweat and fear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘It would be better than debtors’ prison,’ she said tartly. ‘Anyhow, I hope to merely sell him the land.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I’d take prison. Besides, he’ll never buy the land. He wants the land "), _c('em', {
    staticClass: "ITALIC"
  }, [_vm._v("and")]), _vm._v(" you.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I cannot see why Ayrebourne would want to marry a woman like me.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She heard Ren’s sharp intake of breath.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘As always you underestimate yourself,’ he muttered. ‘The Duke is a collector. He likes beautiful things. You are exquisitely beautiful.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I—’ She touched her hands to her face. People had always told her that she had an ephemeral, other-worldly beauty. Indeed, she had traced and retraced her features, pressing her fingers along her jawbone and the outline of her cheeks to find some difference between her own and the faces of others.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She dropped her hands. ‘How did you learn about this anyway?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Jamie.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Jamie? You have seen Jamie already?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Not here. In London. Gambling.’ Ren spoke in a flat, even tone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Jamie gambling?’ Her hand tightened, reflexively balling the cloth of her dress in her fist. ‘I mean—he can’t—he hardly even socialises.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I found him at a gambling house. I removed him, of course, before much harm was done.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘He hates London. When was he even in London?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Last weekend.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘He said he was going to sell two horses at Horbury Mews.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Apparently, he took a less-than-direct route,’ Ren said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beth’s thoughts whirled, bouncing around her mind, quick and panicked. It did not make sense. Jamie was so...so entirely different than Father. Where Father had been glib, Jamie spoke either in monosyllables or else was mired in pedantic detail and scientific hypothesis.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘But why? Why would he do that? He knows only too well the harm gambling can do.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I presume he hopes his facility with numbers will enable him to be more successful than your father.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Except his inability with people will make him more disastrous.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For a moment she was silent. Then she stood, rousing herself with a conscious effort, keeping her hand on the back of her chair to orientate herself. This was not Ren’s problem. She had not seen him for years and he had no need to make some heroic sacrifice for her or her family.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Thank you for telling me about Jamie. I will speak to him,’ she said stiffly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Logic seldom wins against desperation.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘He has no reason to be desperate.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘He loves you and he loves this land. He’d hate to see you married to the Duke and he’d hate to sell as much as a blade of grass. He was cataloguing seeds when he was three.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Seven,’ she corrected. ‘He was cataloguing seeds when he was seven. But I will determine another solution.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I have presented you with another solution.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Marriage? To you?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I am not the devil incarnate, only a close relative.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She released the chair, taking the four steps to the window, as though physical distance might serve to clear her thoughts. She could feel his presence. Even without sight, she was aware of his height, the deep timbre of his voice, the smell of hay and soap, now tinged with tobacco. There was a disorienting mix of familiarity and new strangeness. He was both the boy she had once known and this stranger who had just now bounded back into her life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beth wished she could touch his face. She wanted to read his features, as she would have done once without thought, an action as natural as breathing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘You do not come here for ten years and now turn up with a—a marriage proposal. How would marriage even help? It would not enable us to pay off Father’s debt. I already suggested to your brother that he buy the land, but he is as poor as we are.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ren laughed in a manner devoid of humour. ‘In contrast to my brother, I am a veritable Croesus. And you need not fear, I know you require independence and dislike the concept of marriage. This will be a marriage in name only.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘But why?’ she asked, then flushed, turning. ‘I did not mean—I mean, why marry me? Could you not just buy the land or loan us the money if you are so rich and eager to save us?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She heard the rustle of cloth as though Ren had shrugged and could almost feel his lips curl in a derisive smile. ‘It would provide you with a guardian.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I do not need a guardian.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘You are not yet twenty-one.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I have Jamie.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘He is not yet twenty. Besides, he is no match for Ayrebourne. Marriage to me would make any marriage to the Duke impossible.’ He paused. ‘You were my best friend, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beth rubbed her fingers against the smooth finish of the painted sill, while leaning her forehead against the pane. Her eyes stung with the flood of memories: long afternoons beside the brook, winter walks with the snow crisply crunching under their feet and long tramps through whistling windy days in fall.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Childhood friendship does not require this level of sacrifice. You and I haven’t spoken in years.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For a moment he did not respond, but when he did, something in his voice sent a nervous tingling through her body making her breath uneven.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘You know with us that doesn’t matter.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She felt it, that intangible connection, that closeness that was rooted in childhood, but it had also changed. She heard him shift. She heard his breath quicken.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She bit her lip. ‘Why didn’t you write or come back or visit?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was a pause. She heard his discomfort, the intake of his breath and the movement of his clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I couldn’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘It doesn’t take much. You inhale and speak. You pick up a pen or...or hire a horse.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘You’ll just have to believe me.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘And now you expect me to marry you after all these years?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I expect nothing. I am merely offering a preferable alternative to the Duke,’ he said, his voice now hard and clipped.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shivered. Few things frightened her, but the Duke was one of them. Marriage to him would destroy her. Even if she avoided that and he agreed to buy the land, it was an unpleasant concept and would give him even more reason to linger in the village or woods. She rubbed her arms. Goose pimples prickled the skin. She hated the thought of him owning the land on her own doorstep. Already, she felt watched. And sometimes, as she walked through the woods, she’d smell that odd sweet fragrance that seemed to emanate from him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Duke would use everything against her: her sex, her youth, her poverty, her sightless eyes, her wonderfully odd brother.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ren stepped closer to her. She felt his breath on her neck, his tall presence behind her and his hand on her own. Warmth filled her, which was both comfortable and uncomfortable. The urge for distance and separation lessened so that, for an impulsive, crazy moment, she wanted only to lean against him and to feel his strength.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ren was her friend. He had guided her over rivers and up steep hillsides.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His hand stilled the nervous movement of her fingers against the sill. ‘You can trust me.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Let me honour our childhood friendship.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘We were good friends.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His grip tightened and she felt the warmth grow, a tingling energy snaking through her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘The best. Don’t put yourself in that man’s power. Let me help,’ he said in a voice now oddly soft. ‘Don’t marry him.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I don’t have the option to be selective,’ she muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘You do now.’")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57739022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_One.vue
// module id = 84
// module chunks = 0